import { Headset } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconHeadset12Line = createIcon(Headset, 12, "Line");
export const IconHeadset16Line = createIcon(Headset, 16, "Line");
export const IconHeadset20Line = createIcon(Headset, 20, "Line");
export const IconHeadset24Line = createIcon(Headset, 24, "Line");
export const IconHeadset32Line = createIcon(Headset, 32, "Line");
export const IconHeadset48Line = createIcon(Headset, 48, "Line");
export const IconHeadset64Line = createIcon(Headset, 64, "Line");
